export * from "-!../../../../../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./virtual-sport-game.vue?vue&type=template&id=4c3cbb70"


//////////////////
// WEBPACK FOOTER
// ./skins/bulmasite/components/pages/sitepages/virtual-sports/virtual-sport-game/virtual-sport-game.vue?vue&type=template&id=4c3cbb70
// module id = OgvE
// module chunks = 0